import isNumber from './isNumber'
export default isNumber